// Libraries
import React, {CSSProperties} from 'react'
// Components
import {ErrorNotification} from './ErrorNotification'
import {DangerAlert} from './DangerAlert'

interface Props {
  style: CSSProperties
}

export const ProvisioningError = ({style}: Props): JSX.Element => {
  return (
    <>
      <ErrorNotification>
        Organization could not be provisioned.
      </ErrorNotification>

      <DangerAlert style={style}>
        <span>
          We were not able to set up your environment. If this issue persists,
          please contact{' '}
          <a href="mailto:support@influxdata.com">support@influxdata.com</a>
        </span>
      </DangerAlert>
    </>
  )
}
